export function logActionShared(
    url: string,
    bodyObject: object,
    name: string,
): string {
    try {
        const body = JSON.stringify(bodyObject);
        if (typeof navigator?.sendBeacon === 'function') {
            const sent = navigator.sendBeacon.bind(navigator)(url, body);
            if (!sent) {
                console.error(`flux action '${url}' '${name}' too large`);
            }
        } else {
            fetch(url, {
                method: 'POST',
                body,
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                keepalive: true,
            }).catch((err: unknown) => {
                console.error(
                    `Fallback request failed for '${url}' using fetchApi.`,
                    err,
                );
            });
        }
    } catch (e) {
        console.error(e);
    }
    return 'logged-action';
}
